import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {View, Text, Platform} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {LinearGradient} from 'expo-linear-gradient';
import {
  useLocation,
  useLocationId,
  usePercentageComplete,
} from '../../Hooks/gameHooks';

import {useSafeAreaInsets} from 'react-native-safe-area-context';
import DashedLine from '../../Modules/DashedLine';
import FastImage from 'src/Utils/FastImage';
import {DistanceAway} from '../Game/DistanceAway';
import UserIcon from 'src/HeaderComponents/UserIcon';
import {TouchableOpacity} from 'react-native-gesture-handler';
import {navigationRef} from '../../Nav/navigationHelpers';
import {ordinalSuffixOf} from '../../Utils/helpers';

import Icon from 'react-native-vector-icons/FontAwesome';
import ClassicHuntHeaderTimer from '../../HeaderComponents/ClassicHuntHeaderTimer';

const GameHeader = () => {
  const {width} = useWindowDimensionsSafe();

  const timerLimitMinutes = useSelector(
    (state) => state.game_v2?.timerLimitMinutes,
  );

  const allChallenges =
    useSelector((state) => state.game_v2?.allChallenges) || {};
  const groupPhoto = useSelector((state) => state.groupInfo?.groupPhoto);
  const score = useSelector((state) => state.groupInfo?.score);
  const ordinal_place = useSelector((state) => {
    // use regular rank
    // from cloud function updateScore and lr_app_group_score_log
    if (!state?.event?.eventId) {
      return state.groupInfo?.ordinal_place || 200;
    } else {
      var groupScores = Object.values(state.event?.info?.groupScores || {});
      if (!groupScores) {
        return 200;
      }
      groupScores = groupScores.sort((a, b) =>
        (b.points || 0) > (a.points || 0) ? 1 : -1,
      );

      console.log({groupScores});

      var rank = 200;
      var currentRank = 1;

      groupScores?.map((score) => {
        if (score.groupId === state?.groupInfo?.groupId) {
          rank = currentRank;
        }
        currentRank++;
      });

      return rank;
    }

    // is a corporate event use that instead
  });

  const currentScreen = useSelector(
    (state) => state.current_screen?.currentScreen,
  );

  const isLoading = useSelector((state) =>
    ['LoadingScreen', 'HuntLoading']?.includes(
      state.current_screen?.currentScreen,
    ),
  );

  const locationId = useLocationId();

  console.log({locationId});

  const location = useLocation();

  const {groupPointsEarned = 0, challengeList = []} = location;

  const challengeScore =
    (challengeList || []).reduce((score, key) => {
      let {playerPointsEarned = 0, groupPointsEarned = 0} =
        allChallenges[key] || {};
      return score + playerPointsEarned + groupPointsEarned;
    }, 0) || 0;

  console.log('LocationComplete Render', {
    groupPointsEarned,
    challengeScore,
    score,
  });

  const {locationIndex = 0} = useLocation();

  const percentageComplete = usePercentageComplete();

  const locationCount = useSelector(
    (state) => state?.game_v2?.locationList?.length || 4,
  );

  const insets = useSafeAreaInsets();

  console.log({percentageComplete});

  const activeScreenRef = useRef(currentScreen);

  useEffect(() => {
    if (
      [
        'ConfirmModal',
        'ChallengeAttemptModal',
        'ShareModal',
        'ChallengeResultModal',
      ]?.includes(currentScreen) ||
      currentScreen?.includes('Modal')
    ) {
      activeScreenRef.current = currentScreen;
    }
  }, [currentScreen]);

  var message;
  if (activeScreenRef.current == 'TeamPhoto') {
    message = 'Take A Team Photo';
  } else if (
    activeScreenRef.current == 'LocationChallenges' ||
    activeScreenRef.current == 'ChallengeAttemptModal'
  ) {
    message = 'Complete Challenges At Location';
  } else if (activeScreenRef.current == 'LocationComplete') {
    message = 'You Finished A Location';
  } else if (activeScreenRef.current == 'HuntIntro') {
    message = 'Begin Your Hunt Below';
  } else if (activeScreenRef.current == 'ScavengerHuntGameLobby') {
    message = 'Add Players or Start Your Hunt';
  }

  if (isLoading) {
    return <View></View>;
  }

  return (
    <View style={{backgroundColor: 'white', marginBottom: -1}}>
      <View
        style={{
          width,
          backgroundColor: global.color.blue,
          borderBottomRightRadius: 30,
          borderBottomLeftRadius: 30,
        }}>
        <View
          style={{
            // backgroundColor: global.color.orange,
            width,
            overflow: 'hidden',
            borderBottomRightRadius: 30,
            borderBottomLeftRadius: 30,
            position: 'relative',
          }}>
          <LinearGradient
            colors={['#E87722', '#E88D22']}
            start={[0.2, 0.8]}
            end={[1, 0.2]}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderBottomRightRadius: 30,
              borderBottomLeftRadius: 30,
            }}
          />
          <FastImage
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: -20,
            }}
            resizeMode={'stretch'}
            source={require('src/Images/GameHeaderEffect.png')}
          />
          <View
            style={{
              marginTop: insets.top + (Platform.OS == 'web' ? 30 : 0),
              paddingLeft: 30,
              paddingRight: 30,
            }}>
            <View
              style={{
                position: 'relative',
                height: 50,
                flexDirection: 'row',

                justifyContent: 'space-between',
              }}>
              <View
                style={{
                  position: 'relative',
                  height: 50,
                  flexDirection: 'row',
                }}>
                <View style={{width: 50, marginLeft: -10}}>
                  <UserIcon
                    hideBadges
                    containerStyle={{
                      marginTop: -10,

                      width: 50,
                    }}
                    userPhoto={!!groupPhoto ? {uri: groupPhoto} : undefined}
                  />
                </View>
                <View>
                  <Text
                    style={{
                      color: 'white',
                      fontFamily: 'JakartaBold',
                      fontSize: 14,
                    }}>
                    {ordinal_place > 100 || !ordinal_place
                      ? 'Rank: Top 50%'
                      : `${ordinalSuffixOf(ordinal_place)} Place`}
                  </Text>
                  <Text
                    style={{
                      color: 'white',
                      fontFamily: 'Jakarta',
                      fontSize: 14,
                    }}>
                    {Math.round(score || 0)?.toLocaleString?.() || 0} pts
                  </Text>
                </View>
              </View>
              <View
                style={{
                  position: 'relative',
                  height: 50,
                  flexDirection: 'row',
                  // backgroundColor: 'red',
                  justifyContent: 'space-between',
                }}>
                <TouchableOpacity
                  onPress={() => {
                    navigationRef.navigate('LandingPage');
                  }}
                  style={{padding: 5, paddingHorizontal: 8}}>
                  <FastImage
                    style={{width: 22, height: 22}}
                    resizeMode={FastImage?.resizeMode?.contain}
                    source={require('src/Images/HomeIcon.png')}
                  />
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={() => {
                    navigationRef.navigate('HuntPhotos');
                  }}
                  style={{padding: 5, paddingHorizontal: 8}}>
                  <FastImage
                    style={{width: 22, height: 22}}
                    resizeMode={FastImage?.resizeMode?.contain}
                    source={require('src/Images/Icons/PhotosIcon.png')}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  testID="Dashboard"
                  onPress={() => {
                    navigationRef.navigate('PlayerDashboard_v2');
                  }}
                  style={{padding: 5}}>
                  <Icon
                    style={{width: 22, height: 22}}
                    name={'gear'}
                    size={24}
                    color={'white'}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    navigationRef.navigate('ReportModal');
                  }}
                  style={{
                    padding: 5,
                    paddingHorizontal: 8,
                    paddingRight: 0,
                    marginRight: -10,
                  }}>
                  <FastImage
                    style={{width: 22, height: 22}}
                    resizeMode={FastImage?.resizeMode?.contain}
                    source={require('src/Images/FlagIcon.png')}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <View
              style={{
                position: 'relative',
                height: 22,
                flexDirection: 'row',
                marginTop: 2,
              }}>
              <DashedLine
                dashColor={'white'}
                style={{}}
                widthOveride={
                  ((width - 78 - (timerLimitMinutes ? 70 : 0)) *
                    percentageComplete) /
                  100
                }
              />
              <FastImage
                style={{
                  width: 14,
                  height: 22,
                  top: -10,
                  marginLeft: 2,
                  marginRight: 2,
                }}
                resizeMode={'stretch'}
                source={require('src/Images/Walkingman.png')}
              />
              <DashedLine
                dashColor={'#ffffff88'}
                style={{}}
                widthOveride={
                  ((width - 78 - (timerLimitMinutes ? 70 : 0)) *
                    (100 - percentageComplete)) /
                  100
                }
              />
              {!!timerLimitMinutes && (
                <ClassicHuntHeaderTimer
                  style={{
                    right: -20,
                    height: 30,
                    top: -15,
                    width: 50,
                    borderBottomRightRadius: 10,
                  }}
                />
              )}
            </View>
          </View>
        </View>
        {!!message && (
          <View
            style={{
              height: 30,
              paddingLeft: 30,
              paddingRight: 30,
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
            }}>
            <Text
              style={{color: 'white', fontFamily: 'JakartaBold', fontSize: 14}}>
              {message}
            </Text>
          </View>
        )}
        {activeScreenRef.current == 'NavigationChallenge' && (
          <View
            style={{
              height: 30,
              paddingLeft: 30,
              paddingRight: 30,
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
            }}>
            <Text
              style={{color: 'white', fontFamily: 'JakartaBold', fontSize: 14}}>
              Go to stop {locationIndex + 1} of {locationCount}
            </Text>
            <View>
              <DistanceAway textOnly={true} />
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default GameHeader;
